<div fxLayout="row" style="display:flex; align-items: center; flex-wrap: wrap; gap: 10px;">
    <h4 style="font-size: 17px; font-family: 'poppins'; font-weight: 500; position: relative; left: 20px; top: 5px;"
        fxFlex>Trip View</h4>
    <!-- <button class="btn red-btn-solid" *ngIf="searchButtonFlag" (click)="stopTrip()">
        Stop Trip
    </button> -->
    <button class="btn red-btn-solid" (click)="performTripAction('RESET')">
        Reset Trip
    </button>
    <button class="btn red-btn-solid" (click)="performTripAction('STOP')">
        Manual Stop
    </button>
    <button class="btn red-btn-solid" (click)="performTripAction('RESTART')">
        Restart vehicle
    </button>
    <button class="btn grey-btn-solid" *ngIf="modifyshow && modifyButtonFlag" (click)="modify()">
        Modify
    </button>
    <span style="display: flex; align-items: center; gap: 6px; white-space: nowrap; font-size: 14px; font-weight: 500; font-family: 'poppins' !important;">
        Home Points
        <ui-switch defaultBoColor="#dfdfdf" color="#34c38f" [(ngModel)]="showHomePoints"
            (change)="onToggleHomePoints($event)" style="position: relative; top: 3px;"></ui-switch>
    </span>
    <b style="font-size: 15px; font-weight: 500; font-family: 'poppins' !important;">Trip Code :
    </b>{{dialogData.data.tripCode}}
    <button mat-icon-button (click)="onClickCancel()">
        <mat-icon style="color:#FF0000; position: relative; bottom: 3px;">clear</mat-icon>
    </button>
</div>
<div class="hr-line"></div>
<div fxLayout="row">
    <mat-card class="emp-card">
        <mat-card-content>
            <div class="table-responsive">
                <table fxFlex class="table table-striped mb-0">
                    <thead>
                        <tr>
                            <th style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important;"> SlNo
                            </th>
                            <th style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important;">
                                EmployeeId </th>
                            <th style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important;">
                                EmployeeName </th>
                            <th style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important;"> Location
                            </th>
                            <th
                                style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important; white-space: nowrap;">
                                Zone Name </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let user of dialogData1">
                        <tr *ngFor="let user1 of user.data.tripUsers">
                            <td style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;">
                                {{user1.routedOrder}} </td>
                            <td style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;">
                                {{user1.tripUser.userInfoDetails.employeeId}} </td>
                            <td style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;">
                                {{user1.tripUser.userInfoDetails.displayName}} </td>
                            <td style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;">
                                {{ user1.landmark.area.area !== "Not Available" ? user1.landmark.area.area + ', ' : ''}}
                                {{ user1.landmark.landmark }} </td>
                            <td style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;">
                                {{zoneName}} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="map-card">
        <div class="map-wrapper">
            <div id="trip-map-google-search" class="map-google-search" *ngIf="showGoogleMap">
                <button type="button" class="map-search-toggle" *ngIf="!showGoogleSearch"
                    (click)="openGoogleMapSearch()" title="Search place">
                    <span class="material-icons-outlined">search</span>
                </button>
                <div class="map-search-expanded" *ngIf="showGoogleSearch">
                    <div id="autocomplete-container" class="map-search-container"></div>
                    <button type="button" class="map-search-close" (click)="closeGoogleMapSearch()"
                        title="Close search">
                        <span class="material-icons-outlined">close</span>
                    </button>
                </div>
            </div>
            <div id="map"></div>
        </div>
    </mat-card>
</div>